import React from "react";
import Box from "components/common/Box";
import Rating from "@mui/material/Rating";
import { makeStyles } from "@mui/styles";

const Reviews = ({ props }) => {
  const classes = useStyles();
  const arr = props?.map((prop, i) => (
    <Box className={classes.container}>
      <Box
        className={
          props[i].is_station === 1 ? classes.parentBox1 : classes.parentBox
        }
        key={i}
      >
        <img
          style={{ margin: "1.5rem 0.5rem 0.5rem 0.5rem" }}
          src="/images/doubleQ.png"
          width="28px"
          height="23px"
          alt="doubleQ"
        />
        <br />

        <Box sx={{ margin: "0.5rem" }}>
          <p
            style={{
              fontSize: "13px",
              color: "#4F4F4F",
              fontWeight: "600",
            }}
          >
            {props[i].location}
          </p>
          <p
            style={{
              fontSize: "13px",
            }}
          >
            {props[i].feedback}
           
          </p>
        </Box>

        <Box className={classes.childBox} sx={{display:"flex"}}>
          <img src={props[i].dp}
          style={{
            width:"41px" ,
          height:"42px",
           marginLeft:"5px",
           borderRadius:"20px"
          }}
            alt="dp" />
          <Box>
            <h1
              style={{
                margin: "0px 10px",
                display: "block",
                fontSize: "12px",
              }}
            >
              {props[i].name}
            </h1>
            <Box sx={{marginLeft:"7px", }}>
              <Rating sx={{fontSize:"15px"}} name="read-only" value={props[i].rating} readOnly />

              {props[i].date}
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  ));
  return <>{arr}</>;
};
const useStyles = makeStyles((theme) => ({
  parentBox: {
    border: "1px solid #EBEBEB",
    margin: "0.5rem",
    padding: "1rem",
    color: "#4F4F4F",
    width: "27rem",

    "@media (max-width:768px)": {
      marginLeft: "-1px",
      width: "88%",
    },
  },
  parentBox1: {
    border: "1px solid #EBEBEB",
    padding: "20px",
    margin: "0.5rem",
   
    color: "#4F4F4F",
    borderRadius: "4px",
    width: "90%",
  },
  container: {},
}));

export default Reviews;
